import React from "react";

import { CountryCode } from "~/helpers/country/types";
import { AtFlag24 } from "~/theme/icons/components/at-flag";
import { BeFlag24 } from "~/theme/icons/components/be-flag";
import { CzFlag24 } from "~/theme/icons/components/cz-flag";
import { DeFlag24 } from "~/theme/icons/components/de-flag";
import { EsFlag24 } from "~/theme/icons/components/es-flag";
import { FrFlag24 } from "~/theme/icons/components/fr-flag";
import { IeFlag24 } from "~/theme/icons/components/ie-flag";
import { ItFlag24 } from "~/theme/icons/components/it-flag";
import { NlFlag24 } from "~/theme/icons/components/ni-flag";
import { PlFlag24 } from "~/theme/icons/components/pl-flag";
import { PtFlag24 } from "~/theme/icons/components/pt-flag";
import { RoFlag24 } from "~/theme/icons/components/ro-flag";
import { SiFlag24 } from "~/theme/icons/components/si-flag";
import { SkFlag24 } from "~/theme/icons/components/sk-flag";
import { UkFlag24 } from "~/theme/icons/components/uk-flag";
import { UsFlag24 } from "~/theme/icons/components/us-flag";

const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
export const AVAILABLE_COUNTRIES: Record<
  CountryCode,
  { title?: string; icon: React.FC; currencySymbol: string }
> = {
  [CountryCode.AT]: {
    title: regionNames.of(CountryCode.AT),
    icon: AtFlag24,
    currencySymbol: "€",
  },
  [CountryCode.BE]: {
    title: regionNames.of(CountryCode.BE),
    icon: BeFlag24,
    currencySymbol: "€",
  },
  [CountryCode.CZ]: {
    title: regionNames.of(CountryCode.CZ),
    icon: CzFlag24,
    currencySymbol: "Kč",
  },
  [CountryCode.DE]: {
    title: regionNames.of(CountryCode.DE),
    icon: DeFlag24,
    currencySymbol: "€",
  },
  [CountryCode.ES]: {
    title: regionNames.of(CountryCode.ES),
    icon: EsFlag24,
    currencySymbol: "€",
  },
  [CountryCode.FR]: {
    title: regionNames.of(CountryCode.FR),
    icon: FrFlag24,
    currencySymbol: "€",
  },
  [CountryCode.IE]: {
    title: regionNames.of(CountryCode.IE),
    icon: IeFlag24,
    currencySymbol: "€",
  },
  [CountryCode.US]: {
    title: regionNames.of(CountryCode.US),
    icon: UsFlag24,
    currencySymbol: "€",
  },
  [CountryCode.NL]: {
    title: regionNames.of(CountryCode.NL),
    icon: NlFlag24,
    currencySymbol: "€",
  },
  [CountryCode.PL]: {
    title: regionNames.of(CountryCode.PL),
    icon: PlFlag24,
    currencySymbol: "zł",
  },
  [CountryCode.GB]: {
    title: regionNames.of(CountryCode.GB),
    icon: UkFlag24,
    currencySymbol: "£",
  },
  [CountryCode.PT]: {
    title: regionNames.of(CountryCode.PT),
    icon: PtFlag24,
    currencySymbol: "€",
  },
  [CountryCode.SI]: {
    title: regionNames.of(CountryCode.SI),
    icon: SiFlag24,
    currencySymbol: "€",
  },
  [CountryCode.IT]: {
    title: regionNames.of(CountryCode.IT),
    icon: ItFlag24,
    currencySymbol: "€",
  },
  [CountryCode.SK]: {
    title: regionNames.of(CountryCode.SK),
    icon: SkFlag24,
    currencySymbol: "€",
  },
  [CountryCode.RO]: {
    title: regionNames.of(CountryCode.RO),
    icon: RoFlag24,
    currencySymbol: "LEI",
  },
};

const COUNTRY_SELECTOR_CLASSES_PREFIX = "CountrySelector";

export const COUNTRY_SELECTOR_CLASSES = {
  icon: `${COUNTRY_SELECTOR_CLASSES_PREFIX}-icon`,
  currentCountryLabel: `${COUNTRY_SELECTOR_CLASSES_PREFIX}-currentCountryLabel`,
  downIcon: `${COUNTRY_SELECTOR_CLASSES_PREFIX}-downIcon`,
  item: `${COUNTRY_SELECTOR_CLASSES_PREFIX}-item`,
  countryLabel: `${COUNTRY_SELECTOR_CLASSES_PREFIX}-countryLabel`,
};
